module.exports = __webpack_public_path__ + "static/media/Tony Stark 2.c3aab539.jpg";